var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',{attrs:{"type":"flex","gutter":24}},[_c('a-col',{attrs:{"span":24}},[(
          _vm.user.status != 'admin' &&   
          _vm.user.status != 'firm' &&
          _vm.user.status != 'firm active'
        )?_c('profile-information'):_vm._e(),(_vm.user.status == 'firm' || _vm.user.status == 'firm active')?_c('FirmProfileForm'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }